import { spreadsheetMap } from "../../../api/campaigns";

// Shared function to handle adding contacts to sourcewhale
export const wrappedSpreadsheetMap = async (body) => {
  const {
    candidates,
    campaignId = null,
    searchEmails = "none",
    searchPhones = "none",
    bulkVerify = false,
    contactTypes = [],
  } = body;

  const mappingData = {
    candidates,
    searchEmails,
    searchPhones,
    bulkVerify,
    contactTypes,
    campaignId,
  };

  const res = await spreadsheetMap(mappingData);

  return {
    campaignId: mappingData.campaignId || "none", // null -> "none"
    existingContacts: true,
    spreadsheetMappingResultId: res.spreadsheetMappingResultId,
  };
};
